import MicOffIcon from '@mui/icons-material/MicOff';
import { CircularProgress, IconButton, useTheme } from '@mui/material';

import MicrophoneOnIcon from '@icons/microphone-on-icon.svg';

interface MicrophoneButtonProps {
    isListening: boolean;
    isHandlingMicConnection: boolean;
    startListening: () => void;
    stopListening: () => void;
}

const MicrophoneButton = ({
    isListening,
    isHandlingMicConnection,
    stopListening,
    startListening,
}: MicrophoneButtonProps) => {
    const theme = useTheme();
    if (isHandlingMicConnection) {
        return (
            <CircularProgress
                size={64}
                sx={{
                    color: theme.palette.customColors.orange,
                }}
            />
        );
    }

    return (
        <IconButton
            onClick={isListening ? stopListening : startListening}
            sx={{
                boxShadow: theme.customShadows.primaryGradient,
                padding: 2.5,
            }}
        >
            {isListening ? (
                <MicOffIcon sx={{ color: 'white', width: 24, height: 24 }} />
            ) : (
                <img src={MicrophoneOnIcon} width={24} height={24} alt='microphone on' />
            )}
        </IconButton>
    );
};

export default MicrophoneButton;
